import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

// style rules
import { Sizes } from "../styles";

const ContentGrid = ({ children, padding, rowGap }) => {
	return (
		<Grid isEmpty={!children.length > 0} rowGap={rowGap} padding={padding}>
			{children}
		</Grid>
	);
};

export default ContentGrid;

ContentGrid.propTypes = {
	children: PropTypes.any,
	padding: PropTypes.string,
	rowGap: PropTypes.string,
};

// having to unset the max width bc it was added to lists stylesheet
// TODO: better handle default list styling
const Grid = styled.ul`
	display: ${(props) => (props.isEmpty ? "block" : "grid")};
	grid-template-columns: 1fr;
	gap: 2.8rem;
	row-gap: ${(props) => props.rowGap && props.rowGap};
	padding: ${(props) => (props.padding ? props.padding : "5.4rem 0 12rem 0")};
	margin: 0;
	max-width: unset;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		grid-template-columns: repeat(auto-fill, minmax(29rem, 1fr));
	}
`;
